import { render, staticRenderFns } from "./editDialog.vue?vue&type=template&id=03207168&scoped=true&"
import script from "./editDialog.vue?vue&type=script&lang=js&"
export * from "./editDialog.vue?vue&type=script&lang=js&"
import style0 from "./editDialog.vue?vue&type=style&index=0&id=03207168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03207168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03207168')) {
      api.createRecord('03207168', component.options)
    } else {
      api.reload('03207168', component.options)
    }
    module.hot.accept("./editDialog.vue?vue&type=template&id=03207168&scoped=true&", function () {
      api.rerender('03207168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotOrder/userGiftOrder/dialog/editDialog.vue"
export default component.exports